import { type PropsWithChildren } from 'react'
import { useNavigate } from 'react-router-dom'
import { Page, type PageMenuItem } from '@dhl-ui/page'
import { HeaderContent } from './HeaderContent'
import { useMenuItems } from './useMenuItems'

export const AppLayout = ({ children }: PropsWithChildren) => {
  const navigate = useNavigate()
  const menuItems = useMenuItems()

  const handleSelect = (arg: PageMenuItem) => {
    navigate(arg.link)
  }

  return (
    <Page
      header={<HeaderContent />}
      sideMenu={
        <Page.SideMenu items={menuItems} onSelect={handleSelect} data-testid="side-navigation-item-terminals" />
      }
    >
      <Page.Content>{children}</Page.Content>
    </Page>
  )
}
